import utils from "../../../utils/utils.js";

export default {
  async fetchSuperUserWorkspaces(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetWorkspaces?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserWorkspaces", responseData.data);
  },
  async fetchSuperUserWorkspaceActiveSources(context, payload) {
    let url = "api/Setting/GetWorkspaceActiveSources";
    if (payload.workspaceId != null && payload.workspaceId !== "") {
      url += `?workspaceId=${payload.workspaceId}`;
    }
    const response = await utils.utility.fetch(url, "GET", null, null);

    context.commit("setSuperUserWorkspaceActiveSources", response.data);
  },
  async fetchSuperUserWorkspaceOwners(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceOwners`,
      "GET",
      null,
      null
    );

    context.commit("setSuperUserWorkspaceOwners", response.data);
  },
  async fetchSuperUserWorkspaceDetail(context, payload) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceDetail?id=${payload.id}`,
      "GET",
      null,
      null
    );

    context.commit("setSuperUserWorkspaceDetail", response.data);
  },

  async postSuperUserWorkspace(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateWorkspace`,
      "POST",
      null,
      payload
    );
  },
  async putSuperUserWorkspace(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateWorkspace`,
      "PUT",
      null,
      payload
    );
  },
};
